import type { NextPage } from "next";
import type { SVGProps } from "react";

interface Props extends SVGProps<SVGSVGElement> {
  isGradient?: boolean;
  gradientId?: string;
  from?: string;
  to?: string;
}

const ArrowLeftIcon: NextPage<Props> = ({
  fill = "currentColor",
  from,
  to,
  gradientId = "ArrowLeftIconGradient",
  isGradient = false,
  ...props
}) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      {isGradient && (
        <defs>
          <linearGradient id={gradientId}>
            <stop offset="0%" stopColor={from} />
            <stop offset="100%" stopColor={to} />
          </linearGradient>
        </defs>
      )}
      <path
        d="M8.96779 18.9683C8.77432 18.9683 8.58083 18.8945 8.43314 18.7468L2.22154 12.5352C1.92615 12.2398 1.92615 11.7612 2.22154 11.4659L8.43314 5.25426C8.72853 4.95887 9.20707 4.95887 9.50246 5.25426C9.79785 5.54965 9.79785 6.02819 9.50246 6.32358L3.82552 12.0005L9.50246 17.6775C9.79785 17.9729 9.79785 18.4514 9.50246 18.7468C9.35477 18.8945 9.16127 18.9683 8.96779 18.9683Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M21.2438 12.7562H2.7562C2.33872 12.7562 2 12.4175 2 12C2 11.5825 2.33872 11.2438 2.7562 11.2438H21.2438C21.6613 11.2438 22 11.5825 22 12C22 12.4175 21.6613 12.7562 21.2438 12.7562Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
    </svg>
  );
};

export default ArrowLeftIcon;
